/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  addEncoderSizePrefix,
  addDecoderSizePrefix,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

/** Audit context metadata (placeholder for future expansion) */
export type AuditContext = {
  /** Context metadata as JSON string */
  metadata: string;
};

export type AuditContextArgs = {
  /** Context metadata as JSON string */
  metadata: string;
};

export function getAuditContextEncoder(): Encoder<AuditContextArgs> {
  return getStructEncoder([
    ["metadata", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
  ]);
}

export function getAuditContextDecoder(): Decoder<AuditContext> {
  return getStructDecoder([
    ["metadata", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
  ]);
}

export function getAuditContextCodec(): Codec<AuditContextArgs, AuditContext> {
  return combineCodec(getAuditContextEncoder(), getAuditContextDecoder());
}
